import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function RADS({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M8.603 5.746a2.856 2.856 0 110 5.712 2.856 2.856 0 010-5.712m2.855 9.652a2.857 2.857 0 11-2.856-2.856 3.94 3.94 0 003.94-3.94 2.856 2.856 0 112.856 2.857 3.94 3.94 0 00-3.94 3.94m3.94 2.856a2.856 2.856 0 110-5.712 2.856 2.856 0 010 5.712m0-1.995a.861.861 0 100-1.722.861.861 0 000 1.722m-6.795 0a.861.861 0 100-1.722.861.861 0 000 1.722m6.795-6.796a.86.86 0 100-1.722.86.86 0 000 1.722m-6.795 0a.861.861 0 100-1.722.861.861 0 000 1.722" /><path  d="M8.603 5.746a2.856 2.856 0 110 5.712 2.856 2.856 0 010-5.712m2.855 9.652a2.856 2.856 0 11-2.856-2.856 3.94 3.94 0 003.94-3.94 2.855 2.855 0 112.856 2.857 3.94 3.94 0 00-3.94 3.94m3.94 2.856a2.856 2.856 0 110-5.712 2.856 2.856 0 010 5.712m0-1.995a.861.861 0 100-1.723.861.861 0 000 1.723m-6.795 0a.861.861 0 100-1.722.861.861 0 000 1.722m6.795-6.796a.861.861 0 100-1.723.861.861 0 000 1.723m-6.795 0a.861.861 0 100-1.722.861.861 0 000 1.722" /></Svg>;
}
RADS.DefaultColor = DefaultColor;
export default RADS;